angular.module('NiacsProjectApp.lms-services', [
  'NiacsProjectApp.services-resources',
  'ngResource',
  ]
)
.factory('Course', ['$resource',
    function($resource){
        var Course = $resource('/lms/api/course/:id', {}, {
          update: { method: 'PUT' },
          query: {
            method:'GET',
            isArray:false,
            transformResponse: listResponse
          },
          enrolled: {
            method: 'GET',
            params: {
                id: 'enrolled_courses'
            },
            isArray: false,
            transformResponse: listResponse
          }
        });
        function listResponse(data,header) {
            var wrapped = angular.fromJson(data);
            wrapped.list = wrapped.list.map(function(c) {
                if(c.startDate) {
                    c.startDate = new Date(c.startDate);
                }
                if(c.endDate) {
                    c.endDate = new Date(c.endDate);
                }
                return new Course(c);
            });
            return wrapped;
        }
        return Course;
}])
.factory('CourseProject',['$q','NiacsProject','NotificationService',function($q,NiacsProject,NotificationService){
    function CourseProject () {
        CourseProject.apply(this,arguments);
    }
    CourseProject.prototype = new NiacsProject();
    // technically the underlying returned objects will remain instances of 
    // NiacsProject but the main thing here is to bring any old project content
    // forward so the application can rely on a consistent state WRT project layout.
    CourseProject.query = (function(superFunc){
        return function(p1,p2) {
            var params,callback;
            if(typeof(p1) === 'function') {
              callback = p1;
            } else {
              params = p1;
              callback = p2;
            }
            // don't forward the callback so it doesn't get called prematurely
            // tell NiacsProject.query to use /lms/api as the prefix in place of /jsonapi
            // so that a special endpint gets used to deal with permission issues for
            // the instructor role.
            // see app_src/js/services/jsonapi/$jsonApiResource/Resource.query 
            // and src/Controller/LmsResource::courseProjects
            var r = superFunc.call(this,params,null,'/lms/api');
            r.$promise = r.$promise.then(function(response) {
                response.list.forEach(function(p) {
                    var migResult = niacs.migrateProject(p);
                    if(migResult) {
                        NotificationService.addInfo("Migrated Property "+p.label+" from version '"+migResult.orig+ "' to '"+p.version+"'");
                    }
                });
                if(callback) {
                    callback(r);
                }
                return r;
            });
            return r;
        };
    })(NiacsProject.query);
    CourseProject.loadAll = function(params) {
        params = params||{};
        var limit = 50; // The max allowed by JSON API
        var offset = 0;
        var def = $q.defer();
        var projects = {
            list:[]
        };
        function next() {
            params['page[limit]'] = limit;
            params['page[offset]'] = offset;
            CourseProject.query(params,function(response) {
                projects.list = projects.list.concat(response.list);
                if(response.list.length < limit) {
                    def.resolve(projects);
                } else {
                    offset += limit;
                    next();
                }
            });
        }
        next();
        return def.promise;
    };
    return CourseProject;
}])
.factory('CourseOffering',['$resource','$sce',function($resource,$sce){
    var CourseOffering = $resource('/lms/api/course/:id/revision/:offering',{},
                    {
                        get: {
                            method: 'GET',
                            transformResponse: function(data,header) {
                                var wrapped = angular.fromJson(data);
                                if(wrapped.materials) {
                                    angular.forEach(Object.keys(wrapped.materials),function(key){
                                        wrapped.materials[key].$content = $sce.trustAsHtml(wrapped.materials[key].content);
                                    });
                                }
                                return new CourseOffering(wrapped);
                            }
                        }
                    });
    CourseOffering.prototype.enrollmentMap = function() {
        if(this.enrollment) {
            var enrollment = this.enrollment;
            return Object.keys(enrollment).reduce(function(map,uid){
                var student = enrollment[uid];
                map[student.mail] = student;
                return map;
            },{});
        }
    };
    CourseOffering.prototype.getHomework = function(id) {
        if(this.homework) {
            if(!this.$homeworkMap) {
                var homework = this.homework,
                    map = {};
                Object.keys(homework).forEach(function(key){
                    homework[key].forEach(function(hw){
                        map[hw.id] = hw;
                    });
                });
                this.$homeworkMap = map;
            }
            return this.$homeworkMap[id];
        }
    };
    return CourseOffering;
}]);
